import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DashboardsDisplayGridRowDataFragmentGql } from './DashboardsDisplayGridRowFragmentGql';

export const DatabaseDownstreamDashboardsQueryGql: DocumentNode = gql`
query DatabaseDownstreamDashboardsQuery($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  databases(filter: { id: $databaseId }) {
    downstreamDashboardsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowDataFragment
      }
    }
  }
}
${DashboardsDisplayGridRowDataFragmentGql}
`;
